import {Ticket} from '@shared/services';
import {SiteInfo} from '@shared/services/api/access-sites.interface';
import {NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {TicketArchivedDisplayState} from "@app/layout/sites/tickets/ticket-utils";


export interface TicketModal<T extends Ticket> {
  site: SiteInfo | null;
  ticket?: T | Partial<T>;
  showViewLinkedTicket?: boolean;
  closeModal?: () => void;
}


export interface TicketDetailsModal<T extends Ticket> extends TicketModal<T> {
  hideInboxControl?: boolean;
  showSiteName?: boolean;
  showSiteNameAsLink?: boolean;
  showOtherEscalatedTicketsCount?: boolean;
  showOtherEscalatedTicketsCountAsLink?: boolean;
  displayArchived?: TicketArchivedDisplayState;
  readOnly?: boolean;
}


export const defaultTicketModalOptions: NgbModalOptions = {
  centered: true,
  windowClass: 'modal-xxl',
  keyboard: true,
  backdrop: 'static',
};


export const modalOptionNotTrappingEscapeKey: Partial<NgbModalOptions> = {
  keyboard: false,
};


export class TicketModalUtil {

  static inflateModalInstance<T extends Ticket>(modalInstance: TicketModal<T>, data: TicketModal<T>) {
    const { ticket } = data;
    if (ticket) {
      modalInstance.ticket = ticket;
    }

    if (data.site) {
      modalInstance.site = data.site;
    }
  }

}
